import React from 'react';
import { Field, useFormikContext } from 'formik';
import { AutoCompleteSelectUI, CheckboxUI, FormErrorUI, FormLabelUI } from '../Interface';
import useParam from '../../context/ParamContext';

const UserDataFields = ({ selectedValues, disabled, submenuNames, autoCompleteOptions }) => {
  const { params } = useParam();
  const { values, setFieldValue, validateField, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mb-5">
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="resourceOneId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text={`${submenuNames[0] ?? 'Erőforrás 1'} hozzárendelése`} />}
          variant="standard"
          helperText={<FormErrorUI message={errors.resourceOneId} />}
          onChange={(_e, newVal) => {
            setFieldValue('resourceOneId', newVal?.value ?? null).then(() => {
              validateField('resourceOneId');
            });
          }}
          disabled={disabled}
          InputLabelProps={{ shrink: values.resourceOneId !== '' }}
          selectedValue={values.resourceOneId}
          selectedLabelValue={selectedValues?.resourceOne?.name}
          dataset={autoCompleteOptions.resourceOne}
        />
      </div>
      {params.SHOW_WEBUSER_EMPLOYEE_FIELD === 'Y' && (
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="employeeId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text={`Dolgozó hozzárendelése`} />}
            variant="standard"
            helperText={<FormErrorUI message={errors.employeeId} />}
            onChange={(_e, newVal) => {
              setFieldValue('employeeId', newVal?.value ?? null).then(() => {
                validateField('employeeId');
              });
            }}
            disabled={disabled}
            InputLabelProps={{ shrink: values.employeeId !== '' }}
            selectedValue={values.employeeId}
            selectedLabelValue={selectedValues?.employee?.name}
            dataset={autoCompleteOptions.employees}
          />
        </div>
      )}
      {params.SHOW_WEBUSER_TECHNOLOGIST_FIELD === 'Y' && (
        <div className="col-span-4 md:col-span-1 pt-3">
          <Field
            name="technologist"
            type="checkbox"
            as={CheckboxUI}
            fullWidth
            label={<FormLabelUI text="Technológus" />}
            disabled={disabled}
          />
        </div>
      )}
      {params.SHOW_WEBUSER_GROUPLEADER_FIELD === 'Y' && (
        <div className="col-span-4 md:col-span-1 pt-3">
          <Field
            name="groupLeader"
            type="checkbox"
            as={CheckboxUI}
            fullWidth
            label={<FormLabelUI text="Csoportvezető" />}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
};

export default UserDataFields;
